(function () {
  const Core = window.RB.Core;

  let byName = null;

  function findCard(nameOrId) {
    const byId = Core.cardById(nameOrId);
    if (byId) return byId;
    if (!byName) {
      byName = {};
      for (const c of window.CARD_DB) {
        const key = c.name.toLowerCase();
        const prev = byName[key];
        if (!prev || (c.set + c.collector_number).localeCompare(prev.set + prev.collector_number) < 0) byName[key] = c;
      }
    }
    return byName[String(nameOrId).toLowerCase()] || null;
  }

  const Setup = {
    findCard: findCard,

    freshTurnFacts() {
      const one = function () {
        return { played: 0, spells: 0, enemyDied: false, unitDied: false, discarded: false, equipmentPlayed: false, gearPlayed: 0, unitsEnterReady: false, freeHides: false, xpGained: 0, abilitiesUsed: 0, gearAbilitiesUsed: 0, maxSpellEnergy: 0, lastSpellEnergy: 0, heldPoints: 0, conqueredPoints: 0, chose: 0, choseEnemy: 0, choseEnemyUnit: 0, spentPower: 0, spentEnergy: 0, drawn: 0, unitDiedBeginning: false, nonTokenUnitsPlayed: 0 };
      };
      return { players: [one(), one()] };
    },

    initialState(setup) {
      const state = {
        rngState: setup.seed | 0,
        nextIid: 1,
        mode: { victory: 8 },
        over: null,
        turn: { num: 0, player: 0, phase: "setup" },
        players: [],
        objs: {},
        battlefields: [],
        chain: [],
        nextChainId: 1,
        showdown: null,
        priority: null,
        passCount: 0,
        chainOpener: null,
        tasks: [],
        pending: null,
        triggerQueue: [],
        fx: [],
        nextFxId: 1,
        needCleanup: false,
        gameLog: [],
        turnFacts: RB.Setup.freshTurnFacts(),
        extraTurns: [0, 0],
        nextPlayMods: [],
      };

      for (let p = 0; p < 2; p++) {
        const d = setup.players[p];
        const player = {
          idx: p,
          name: d.name || "Player " + (p + 1),
          points: 0,
          xp: 0,
          pool: Core.emptyPool(),
          hand: [],
          mainDeck: [],
          runeDeck: [],
          trash: [],
          banish: [],
          champion: [],
          legendIid: null,
          battlefieldChoices: [],
        };
        state.players.push(player);

        const legendCard = findCard(d.legend);
        if (!legendCard) throw new Error("legend not found: " + d.legend);
        const legend = Core.makeObj(state, {
          card: legendCard.id, owner: p, controller: p, zone: "legendZone", ready: true,
        });
        player.legendIid = legend.iid;
        const legendScript = RB.Scripts.forCard(state, legend.iid);
        if (legendScript && legendScript.legendArm) {
          const armItem = {
            controller: p, source: legend.iid, iid: legend.iid,
            targets: {}, vars: {}, ctx: {}, label: legendCard.name,
          };
          for (const op of legendScript.legendArm) RB.FX.runOp(state, armItem, op);
        }

        const champCard = findCard(d.champion);
        if (!champCard) throw new Error("champion not found: " + d.champion);
        const champ = Core.makeObj(state, {
          card: champCard.id, owner: p, controller: p, zone: "champion",
        });
        player.champion.push(champ.iid);
        player.chosenChampion = champCard.id;

        for (const entry of d.deck) {
          const c = findCard(entry);
          if (!c) throw new Error("card not found: " + entry);
          const o = Core.makeObj(state, { card: c.id, owner: p, controller: p, zone: "deck" });
          player.mainDeck.push(o.iid);
        }

        for (const entry of d.runes) {
          const c = findCard(entry);
          if (!c) throw new Error("rune not found: " + entry);
          const o = Core.makeObj(state, { card: c.id, owner: p, controller: p, zone: "runeDeck" });
          player.runeDeck.push(o.iid);
        }

        for (const entry of d.battlefields) {
          const c = findCard(entry);
          if (!c) throw new Error("battlefield not found: " + entry);
          player.battlefieldChoices.push(c.id);
        }
      }

      const first = setup.firstPlayer !== undefined ? setup.firstPlayer : Kernel.rngInt(state, 2);
      state.turn.player = first;
      state.firstPlayer = first;

      for (let p = 0; p < 2; p++) {
        const player = state.players[p];
        const pick = player.battlefieldChoices.length > 1
          ? Kernel.rngInt(state, player.battlefieldChoices.length)
          : 0;
        const bf = Core.makeBattlefield(state, player.battlefieldChoices[pick], p);
        state.battlefields.push(bf.iid);
        Kernel.shuffle(state, player.mainDeck);
        Kernel.shuffle(state, player.runeDeck);
      }

      for (let p = 0; p < 2; p++) {
        for (let i = 0; i < 4; i++) Setup.drawRaw(state, p);
      }

      state.tasks.push({ k: "mulligan", order: [first, Core.otherPlayer(first)], i: 0 });
      Core.log(state, state.players[first].name + " goes first.", { k: "turn", p: first });
      return state;
    },

    drawRaw(state, p) {
      const player = state.players[p];
      if (!player.mainDeck.length) return null;
      const iid = player.mainDeck.shift();
      state.objs[iid].zone = "hand";
      player.hand.push(iid);
      return iid;
    },
  };

  window.RB.Setup = Setup;
})();
